import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfileDataService } from '../services/data/profile-data.service';
import { ProfileAccessDenialCode, ProfileLoadResult } from '../services/data/profile-access.model';

const DENIED_ROUTE: Record<ProfileAccessDenialCode, string> = {
  [ProfileAccessDenialCode.InactiveAccount]: '/etm-account-inactive',
  [ProfileAccessDenialCode.NoProduct]: '/product-entitlement-inactive',
};

function resolveAccess(result: ProfileLoadResult, router: Router): true | UrlTree {
  if (result.status === 'success') return true;
  if (result.status === 'denied') return router.parseUrl(DENIED_ROUTE[result.code]);
  return router.parseUrl('/login-error');
}

export const profileGuard: CanActivateFn = (): Observable<true | UrlTree> => {
  const profileDataService = inject(ProfileDataService);
  const router = inject(Router);

  if (profileDataService.currentProfile) return of(true);

  return profileDataService.loadProfile().pipe(map((result) => resolveAccess(result, router)));
};
